
import {defineComponent} from "vue";
import paycoUtils from "@/assets/js/utils";
import api from "@/api/backend-api";
import store from "@/store";
import router from "@/router";
import {mapState} from "vuex";

export default defineComponent({
  name: 'cellphone-authentication-component',
  data: function () {
    return {
      inputName: '',
      inputPhoneNumber: '',
      authenticationNumber: '',
      personalInformationConsent: false,

      authenticationRequestCount: 0,
      authenticationTimer: 0,
      authenticationExpirationTime: 0,
      remainingMinutes: 0 as number,
      remainingSeconds: 0 as number,
      authenticationTimeExpired: false,
    }
  },
  methods: {
    setInputName(event: Event): void {
      this.inputName = (event.currentTarget as HTMLInputElement).value;
      this.inputName = paycoUtils.removeCharacterExceptKorEng(this.inputName);
    },
    setInputPhoneNumber(event: Event): void {
      this.inputPhoneNumber = (event.currentTarget as HTMLInputElement).value;
      this.inputPhoneNumber = paycoUtils.removeCharacterExceptNumber(this.inputPhoneNumber);
    },
    setAuthenticationNumber(event: Event): void {
      this.authenticationNumber = (event.currentTarget as HTMLInputElement).value;
      this.authenticationNumber = paycoUtils.removeCharacterExceptNumber(this.authenticationNumber);
    },
    sendAuthenticationNumber(): void {
      if (!this.hasInputName) {
        alert('이름을 입력해주세요.');
        return;
      }

      if (!this.checkPhoneNumberLength) {
        alert('휴대전화번호의 길이가 올바르지 않습니다.');
        return;
      }

      api.createCellphoneAuthenticationNumber(this.inputPhoneNumber)
      .then(response => {
        if (response.data.code === 0) {
          clearInterval(this.authenticationTimer);
          this.authenticationTimeExpired = false;

          this.authenticationRequestCount++;
          this.authenticationExpirationTime = new Date().getTime() + (3 * 60 * 1000); // 3분 후
          this.remainingTime = Math.round((this.authenticationExpirationTime - new Date().getTime()) / 1000); // 3분

          this.authenticationTimer = setInterval(() => {
            this.remainingTime = Math.round((this.authenticationExpirationTime - new Date().getTime()) / 1000);
            if (this.remainingTime <= 0) {
              this.authenticationTimeExpired = true;
              clearInterval(this.authenticationTimer);
            }
          }, 1000);

          alert('인증번호를 발송했습니다.');
          return;
        } else if (response.data.code === 429) {
          alert(response.data.message);
          return;
        }
        alert('일시적인 서버오류로 인증번호 발송에 실패했습니다. 다시 시도해주세요.');
      })
      .catch(error => {
        console.log("Error: " + error);
      });
    },
    eraseInputName(): void {
      this.inputName = '';
    },
    eraseInputPhoneNumber(): void {
      this.inputPhoneNumber = '';
    },
    fillZero(time: number): string {
      if (time < 10) {
        return '0' + time;
      }
      return time.toString();
    },
    authenticatePhoneNumber(): void {
      if (!this.checkAuthenticationNumberLength) {
        alert('6자리 인증번호를 입력해주세요.');
        return;
      }

      if (!this.authenticationRequested) {
        alert('인증번호 받기를 눌러주세요.');
        return;
      }

      if (this.authenticationTimeExpired) {
        alert('인증가능시간이 만료되었습니다. 다시 시도해주세요.');
        return;
      }

      // 백엔드 서버에 인증번호와 일치하는지 API 요청
      // 인증 완료 시, 완료되었습니다. 띄우고 휴대전화번호 저장
      // 인증 실패 시, 인증번호가 일치하지 않습니다. 띄울 것
      const phoneNumber = this.inputPhoneNumber;
      api.checkCellphoneAuthenticationNumber(phoneNumber, this.authenticationNumber)
      .then(response => {
        if (response.data.code === 0) {
          alert('휴대폰 인증이 완료되었습니다.');
          store.commit('MemberStore/setPhoneNumber', response.data.result.encryptedPhoneNumber);
          router.push(this.nextView);
          return;
        }

        if (response.data.code === 4023) {
          alert('인증번호가 일치하지 않습니다.');
          return;
        }

        alert('일시적인 서버오류로 휴대폰인증번호 확인에 실패했습니다. 잠시 후, 다시 시도해주세요.');
      })
      .catch(error => {
        console.log("Error: " + error);
      });
    },
  },
  computed: {
    hasInputName(): boolean {
      return this.inputName.length > 0;
    },
    hasInputPhoneNumber(): boolean {
      return this.inputPhoneNumber.length > 0;
    },
    checkPhoneNumberLength(): boolean {
      return this.inputPhoneNumber.length >= 10;
    },
    hasAuthenticationNumber(): boolean {
      return this.authenticationNumber.length > 0;
    },
    checkAuthenticationNumberLength(): boolean {
      return this.authenticationNumber.length >= 6;
    },
    authenticationRequested(): boolean {
      return this.authenticationRequestCount > 0;
    },
    canMoveToNextStep(): boolean {
      return this.hasInputName
        && this.checkPhoneNumberLength
        && this.checkAuthenticationNumberLength
        && this.personalInformationConsent;
    },
    remainingTime: {
      get(): number {
        return (60 * this.remainingMinutes) + this.remainingSeconds;
      },
      set(newValue: number): void {
        this.remainingMinutes = Math.floor(newValue / 60);
        this.remainingSeconds = newValue % 60;
      }
    },
    remainingTimeString(): string {
      if (this.authenticationTimeExpired) {
        return '입력기한만료';
      }
      return this.fillZero(this.remainingMinutes) + ':' + this.fillZero(this.remainingSeconds);
    },
    ...mapState({nextView: (state: any) => state.NextViewStore.nextView})
  }
})
